import { LOADING } from '../constants/ActionTypes';

export const setLoading = ({ message, open }) => ({
  type: LOADING,
  open,
  message
});
